(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp-description-with-features"] && !Shopify.designMode) return;
  try {
    class HpPdpDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-description-content]');
      this.toggleButton = this.querySelector('.hp-pdp-description__toggle');
      this.toggleLabel = this.querySelector('[data-description-label]');
      if (!this.content || !this.toggleButton || !this.toggleLabel) return;

      this.onToggle = () => this.setExpanded(!this.classList.contains('is-expanded'));
      this.onResize = () => this.updateCollapsibleState();
      this.toggleButton.addEventListener('click', this.onToggle);
      window.addEventListener('resize', this.onResize, { passive: true });
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.content);
      }
      this.updateCollapsibleState();
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.updateCollapsibleState();
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.toggleButton?.removeEventListener('click', this.onToggle);
      window.removeEventListener('resize', this.onResize);
    }

    updateCollapsibleState() {
      if (!this.content.clientWidth) return;
      const text = this.content.querySelector('p, li') || this.content;
      const styles = getComputedStyle(text);
      const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.5;
      const collapsedHeight = lineHeight * 3;
      const collapsible = this.content.scrollHeight > collapsedHeight + 1;
      this.style.setProperty('--hp-description-collapsed-height', `${collapsedHeight}px`);
      this.classList.toggle('is-collapsible', collapsible);
      this.toggleButton.hidden = !collapsible;
      if (!collapsible) this.setExpanded(false);
    }

    setExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.toggleButton.setAttribute('aria-expanded', String(expanded));
      this.toggleLabel.textContent = expanded
        ? this.toggleButton.dataset.labelLess
        : this.toggleButton.dataset.labelMore;
    }
  }

  if (!customElements.get('hp-pdp-description')) {
    customElements.define('hp-pdp-description', HpPdpDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
